import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrownUpgrade = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3.6 13.667 2.148 4.594a.4.4 0 0 1 .624-.392l3.687 2.561a.4.4 0 0 0 .565-.113l2.64-4.124a.4.4 0 0 1 .673 0l2.64 4.124a.4.4 0 0 0 .564.113l3.688-2.56a.4.4 0 0 1 .623.391L16.4 13.667zM4.496 17c-.544 0-.896-.367-.896-.933v-.734h12.8v.734c0 .566-.352.933-.896.933z"
	})
});
export default SvgCrownUpgrade;
